export const UploadStatus = {
    UPLOADING: 'UPLOADING',
    UPLOAD_FAILED: 'UPLOAD_FAILED',
    PROCESSING: 'PROCESSING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
    TIMEOUT: 'TIMEOUT'
}